export default {
    workdetail: '作業内容'
};
